import React from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { handleAllExcelDownload } from "utils/excelUtils";
import {
  pricingNoList,
  // pricingQualityList,
  qualityOptionList,
} from "../content/static";
import RadioButton from "components/form/Radio";
import SelectComponent from "components/form/Select";
import InputComponent from "components/form/Input";
import { Form, Button } from "react-bootstrap";
import Alert from "components/Alert";
// import RadioQualityButton from "../components/form/RadioQuality";
import { MultiSelect } from "react-multi-select-component";
const FormComponent = ({
  setIsDisable,
  deletestoneDetails,
  handleReCalculateLabour,
  isDisable,
  metalLotCodeList,
  setSelectedQualityValue,
  selectedQualityValue,
  handleFormSubmit,
  isFormMinimized,
  handleQualityDetails,
  handleCustomerSelect,
  customerOptions,
  selectedCustomer,
  handleFactoryCodeChange,
  factoryCodeList,
  selectedFactoryCode,
  handleGoldRateChange,
  goldRate,
  handleGoldDropdownChange,
  goldButtonText,
  handleSilverRateChange,
  silverRate,
  handleSilverDropdownChange,
  silverButtonText,
  handlePlatinumRateChange,
  handlePaladiumRateChange,
  platinumRate,
  palladiumRate,
  handlePlatinumDropdownChange,
  handlePaladiumDropdownChange,
  handleQualityRadioChange,
  platinumButtonText,
  selectedRadio,
  handleRadioChange,
  rawInputData,
  setRawInputData,
  styleNohandle,
  unitList,
  isLoading,
  disableInputAction,
  pricingNo,
  priceDetails,
  styleCount,
  data,
  updatedUniquePriceNumber,
  selectedCurrency,
  setSelectedCurrency,
  currencyList,
  palladiumButtonText,
  // selectedDiamondQuality,
  selectedDiamondQualityValue,
  setSelectedDiamondQualityValue,
  pricingDate,
  showError,
  errorMessage,
  setErrorHandle,
  setShowError,
  diamondQualityOptionList,
  checked,
  setChecked,
  handleMetalLotCode,
  setMetalLotCodeList,
  setLotCode1,
  lotCode1,
  lotCode2,
  setLotCode2,
  isTwoTone,
  setIsTwoTone,
  setLotCode1Commodity,
  setLotCode2Commodity,
  handleKarateList,
  groupValue,
  setGroupValue
}) => {
  setTimeout(() => {
    setShowError(false);
  }, 7000);

  const style = {
    border: errorMessage.selectedDiamondQualityValue?.length < 0 ? "2px solid red" : "none",
    backgroundColor: errorMessage.selectedDiamondQualityValue?.length < 0 ? "lightcoral" : "transparent",
    zIndex: 1
  };
  
  return (
    <Form
      onSubmit={handleFormSubmit}
      className={`${isFormMinimized ? "d-none" : ""}`}
    >
      <div className="row form_child">
        <div className="col-md-8">
          <div className="d-flex">
            <div className="col-md-4 form-label">
              <label htmlFor="exampleFormControlSelect1">
                Customer Code
                {errorMessage.customerCode && (
                  <span style={{ color: "red" }}>*</span>
                )}
              </label>

              {pricingNo || (priceDetails && priceDetails.length > 0) ? (
                <input
                  style={{ height: "38px" }}
                  type="text"
                  className="form-control form-control-sm"
                  value={selectedCustomer.value}
                  readOnly
                />
              ) : (
                <>
                  <Select
                    value={selectedCustomer}
                    onChange={(selectedOption) =>
                      handleQualityDetails(selectedOption)
                    }
                    onInputChange={handleCustomerSelect}
                    options={customerOptions}
                    defaultValue={selectedCustomer}
                    className={`style-select multiple-select ${
                      errorMessage.customerCode ? "select-invalid" : ""
                    } ${selectedCustomer ? "select-valid" : ""}`}
                    isSearchable={true}
                    placeholder="Select Customer Code"
                    isClearable={true}
                    isDisabled={Boolean(
                      pricingNo || (priceDetails && priceDetails.length > 0)
                    )}
                    isLoading={isLoading}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: errorMessage.customerCode
                          ? "#F8D7DA"
                          : "white",
                      }),
                    }}
                  />

                  {errorMessage.customerCode && (
                    <span className="validation_error">
                      {errorMessage.customerCode}
                    </span>
                  )}
                </>
              )}
            </div>

            <SelectComponent
              label={"Factory Code"}
              id="metalInput"
              optionList={factoryCodeList}
              disabled={Boolean(
                pricingNo || (priceDetails && priceDetails.length > 0)
              )}
              value={selectedFactoryCode}
              onChange={handleFactoryCodeChange}
              className="col-md-4"
            />

            <SelectComponent
              label={"Currency"}
              optionList={currencyList}
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
              className="col-md-4"
              disabled={disableInputAction}
            />
          </div>

          <div className="d-flex mt-1">
            <InputComponent
              label={"Gold Pure Rate"}
              value={goldRate}
              onChange={handleGoldRateChange}
              // onBlur={handleKarateList}
              //required
              disabled={disableInputAction}
              errorMessage={errorMessage.metalRate}
              inputClassName={goldRate && "is-valid"}
              className="col-md-4"
              endDropDownList={{
                activeValue: goldButtonText,
                dropDownOnChange: handleGoldDropdownChange,
                dropDownList: unitList,
              }}
            />

            <InputComponent
              label={"Silver Pure Rate"}
              value={silverRate}
              onChange={handleSilverRateChange}
              //required
              // onBlur={handleKarateList}
              errorMessage={errorMessage.metalRate}
              disabled={disableInputAction}
              className={`col-md-4`}
              inputClassName={silverRate && "is-valid"}
              endDropDownList={{
                activeValue: silverButtonText,
                dropDownOnChange: handleSilverDropdownChange,
                dropDownList: unitList,
              }}
            />
            <div className="col-md-4">
              <div className="form-label">
                <label htmlFor="exampleFormControlSelect1">
                  Metal LotCode1
                </label>

                <div className="select-with-checkbox">
                  <Select
                    isSearchable={true}
                    options={metalLotCodeList.map((option) => ({
                      label: option.label,
                      value: option.value,
                      commodity: option.commodity, // Extract commodity value
                    }))}
                    value={
                      lotCode1
                        ? {
                            label: lotCode1,
                            value: lotCode1,
                            commodity: lotCode1,
                          }
                        : null
                    } // Update value with label and commodity
                    placeholder="Enter Metal LotCode & Select"
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        const selectedValue = selectedOption.value;
                        const selectedCommodity = selectedOption.commodity; // Extract commodity value
                        setLotCode1(selectedValue);
                        // setLotCode1(selectedValue.split("~")[0]); // Update lotCode1
                        setLotCode1Commodity(selectedCommodity); // Update lotCode1Commodity
                        setErrorHandle("lotCode1", undefined);
                      } else {
                        setLotCode1(null);
                      }
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: errorMessage.metalRate || errorMessage.lotCode1
                          ? "#F8D7DA"
                          : "white",
                        ...(state.isFocused && {
                          boxShadow:
                            "0 0 0 1px #0000001f, 0 0 0 0.2rem rgba(0,123,255,.25)",
                        }),
                      }),
                    }}
                    isClearable={true}
                    isLoading={isLoading}
                  />
                </div>

                {errorMessage.metalRate || errorMessage.lotCode1 && (
                  <span className="validation_error">
                    {errorMessage.lotCode1}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex mt-1">
            <InputComponent
              label={"Platinum Pure Rate"}
              value={platinumRate}
              onChange={handlePlatinumRateChange}
              //required
              // onBlur={handleKarateList}
              errorMessage={errorMessage.metalRate}
              disabled={disableInputAction}
              inputClassName={platinumRate && "is-valid"}
              className="mb-2 flex-grow-1 col-md-4"
              endDropDownList={{
                activeValue: platinumButtonText,
                dropDownOnChange: handlePlatinumDropdownChange,
                dropDownList: unitList,
              }}
            />

            <InputComponent
              label={"Palladium Pure Rate"}
              value={palladiumRate}
              onChange={handlePaladiumRateChange}
              //required
              // onBlur={handleKarateList}
              errorMessage={errorMessage.metalRate}
              disabled={disableInputAction}
              className={`col-md-4`}
              inputClassName={palladiumRate && "is-valid"}
              endDropDownList={{
                activeValue: palladiumButtonText,
                dropDownOnChange: handlePaladiumDropdownChange,
                dropDownList: unitList,
              }}
            />

            <div className="col-md-4">
              <div className="form-label">
                <label htmlFor="exampleFormControlSelect1">
                  Metal LotCode2
                </label>

                <div className="select-with-checkbox">
                  <Select
                    isSearchable={true}
                    options={metalLotCodeList.map((option) => ({
                      label: option.label,
                      value: option.value,
                      commodity: option.commodity, // Extract commodity value
                    }))}
                    isDisabled={!isTwoTone}
                    value={
                      lotCode2
                        ? {
                            label: lotCode2,
                            value: lotCode2,
                            commodity: lotCode2,
                          }
                        : null
                    } // Update value with label and commodity
                    placeholder="Enter Metal LotCode & Select"
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        const selectedValue = selectedOption.value;
                        const selectedCommodity = selectedOption.commodity; // Extract commodity value
                        setLotCode2(selectedValue);
                        setLotCode2Commodity(selectedCommodity); // Update lotCode1Commodity
                        setErrorHandle("lotCode2", undefined);
                      } else {
                        setLotCode2(null);
                      }
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        opacity: !isTwoTone ? "0.5" : "1",
                        borderColor: !isTwoTone ? "#d1d1d1" : "#ced4da",
                        backgroundColor: !isTwoTone
                          ? "#f8f9fa"
                          : errorMessage.lotCode2 || errorMessage.metalRate
                          ? "#F8D7DA"
                          : lotCode2
                          ? "white"
                          : "transparent",
                        ...(state.isFocused && {
                          boxShadow:
                            "0 0 0 1px #0000001f, 0 0 0 0.2rem rgba(0,123,255,.25)",
                        }),
                      }),
                    }}
                    isClearable={true}
                    isLoading={isLoading}
                  />
                  <div className="form-check checkbox-metalLotCode">
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefaultTwoTone"
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexCheckDefaultTwoTone"
                        checked={isTwoTone}
                        onChange={() => {
                          setIsTwoTone(!isTwoTone);
                          setLotCode2("");
                        }}
                      />
                      TwoTone
                    </label>
                  </div>
                </div>

                {errorMessage.metalRate || errorMessage.lotCode2 && (
                  <span className="validation_error">
                   {errorMessage.lotCode2}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div id="message" className="message ml-3"></div>

          <div className="d-flex">
            <div className="col-md-4">
              <div className="form-group">
                <label
                  htmlFor="exampleFormControlTextarea1"
                  className="form-label"
                >
                  {selectedRadio === "STYLE"
                    ? "Style No"
                    : selectedRadio === "DESIGN"
                    ? "Design No"
                    : selectedRadio === "STYLE_STONE"
                    ? "Style StoneCard No"
                    : selectedRadio === "DESIGN_STONE"
                    ? "Design StoneCard No"
                    : "Contract"}
                  {errorMessage.inputData && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                </label>
                <textarea
                  className={`form-control ${
                    errorMessage.inputData
                      ? "is-invalid validation_error_background"
                      : ""
                  } ${rawInputData ? "is-valid" : ""}`}
                  id="exampleFormControlTextarea1"
                  rows="4"
                  value={rawInputData}
                  onChange={(e) => {
                    setRawInputData(e.target.value);
                    setErrorHandle("inputData", undefined);
                  }}
                  onBlur={styleNohandle}
                  style={{ resize: "none" }}
                ></textarea>

                {errorMessage.inputData && (
                  <span className="validation_error pl-1">
                    {errorMessage.inputData}
                  </span>
                )}
              </div>

              <div id="errorMsg" className="message ml-3"></div>
            </div>

            <div className="col-md-4">
              <div>
                <label
                  htmlFor="exampleFormControlSelect1"
                  className="form-label "
                >
                  Quality Type &nbsp;
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      color: "#a6a6a6",
                    }}
                  >
                    (Check tick mark <FontAwesomeIcon icon={faSquareCheck} />{" "}
                    for LotMaster)
                  </span>
                </label>

                <div className="select-with-checkbox">
                  <Select
                    options={qualityOptionList || []} // Add a fallback value if qualityOptionList is null or undefined
                    value={selectedQualityValue || null} // Add a fallback value if selectedQualityValue is null or undefined
                    onChange={(selectedOption) => {
                      if (selectedOption.value === "QUALITYGROUP") {
                        setChecked(false);
                       setGroupValue(false)
                      }
                      setSelectedDiamondQualityValue(null);
                      handleQualityRadioChange(selectedOption);
                    }}
                    className={`style-select multiple-select ${
                      errorMessage.customerCode ||
                      errorMessage.selectedQualityValue
                        ? "select-invalid"
                        : ""
                    } ${selectedQualityValue ? "select-valid" : ""}`}
                    isSearchable
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: errorMessage.selectedQualityValue
                          ? "#F8D7DA"
                          : "white",
                        height: "42px",
                        zIndex: 0,
                      }),
                    }}
                  />

                  <div className="form-check checkbox-lotmaster">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                      disabled={
                        isDisable ||
                        selectedQualityValue?.value === "QUALITYGROUP"
                      }
                      checked={checked}
                      onChange={() => {
                        setChecked(!checked);
                      }}
                    />

                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      LotMaster
                    </label>
                  </div>
                </div>

                {errorMessage.customerCode && (
                  <span className="validation_error">
                    {`${errorMessage.customerCode} or a Quality type`}
                  </span>
                )}
                <div
                  className="my-4  d-flex"
                  style={{ left: "416px", bottom: "50px" }}
                >
                  <div className="d-flex">
                    <Button
                      type="submit"
                      className="btn btn-dark"
                      style={{ width: "160px", height: "40px" }}
                    >
                      {pricingNo || (priceDetails && priceDetails.length > 0)
                        ? "Update Quotation"
                        : "Create Quotation"}
                    </Button>
                    {showError && (
                      <Alert
                        key={"danger"}
                        variant={"danger"}
                        message={
                          "Please fill out all required fields correctly."
                        }
                        className={"ml-3 alert_formError"}
                        showAlert={showError}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <label
                htmlFor="exampleFormControlSelect1"
                className="form-label "
              >
                Quality &nbsp;
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    marginLeft: "1px",
                    color: "#a6a6a6",
                  }}
                >
                  {selectedDiamondQualityValue?.length === 0 ? (
                    <span>0 selected</span>
                  ) : selectedDiamondQualityValue?.length >= 10 ? (
                    <span>10 options selected</span>
                  ) : (
                    <span>
                      {selectedDiamondQualityValue
                        ? selectedDiamondQualityValue.length ===
                          diamondQualityOptionList.length
                          ? "All options selected"
                          : `${selectedDiamondQualityValue.length} option(s) selected`
                        : "0 options selected"}
                    </span>
                  )}
                </span>
                {groupValue ? (
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "normal",
                      marginLeft: "10px",
                      color: "#dc3545",
                    }}
                  >
                    *maximum 10 quality only
                  </span>
                ):(
                  <></>
                )}
              </label>

              {/* <Select
                value={selectedDiamondQualityValue}
                isDisabled={
                  selectedDiamondQualityValue
                    ? selectedDiamondQualityValue.value
                    : selectedDiamondQualityValue
                }
                options={diamondQualityOptionList}
                onChange={(selectedOption) => {
                  setSelectedDiamondQualityValue(selectedOption);

                  // console.log("option", selectedOption);
                  // setErrorHandle("diamondQuality", undefined);
                }}
                className={`form-groug-sm pl-0 ${
                  errorMessage.selectedQualityValue ? "is-invalid " : ""
                } ${selectedDiamondQualityValue ? "is-valid" : ""}`}
                isMulti
                components={{
                  DropdownIndicator,
                  Option: (props) => <components.Option {...props} />,
                  Menu: (props) => (
                    <components.Menu {...props}>
                      {props.children}
                      <SelectAllButton />
                    </components.Menu>
                  ),
                }}
                styles={{
                  multiValueLabel: (base) => ({
                    ...base,
                    color: "blue",
                  }),
                  control: (base, state) => ({
                    ...base,
                    minHeight: "40px",
                    backgroundColor: state.isDisabled
                      ? "#f8f9fa" // Background color when disabled
                      : selectedDiamondQualityValue
                      ? ""
                      : errorMessage.selectedDiamondQualityValue
                      ? "#F8D7DA"
                      : state.borderColor,
                    opacity: state.isDisabled ? 0.6 : 1, // Opacity when disabled
                    borderColor: state.isDisabled ? "#CCCCCC" : "#CCCCCC", // Border color when disabled
                    cursor: state.isDisabled ? "not-allowed" : "pointer", // Cursor style when disabled
                    "&:hover": {
                      borderColor: selectedDiamondQualityValue
                        ? "green"
                        : errorMessage.selectedDiamondQualityValue
                        ? "red"
                        : state.borderColor,
                      backgroundColor: selectedDiamondQualityValue
                        ? ""
                        : errorMessage.selectedDiamondQualityValue
                        ? "#F8D7DA"
                        : state.borderColor,
                    },
                  }),
                }}
              /> */}

              <MultiSelect
                options={
                  // selectedDiamondQualityValue?.length >= 10
                  // ?
                  diamondQualityOptionList
                  // .filter((option) =>
                  //     selectedDiamondQualityValue.includes(option)
                  //   )
                  // : diamondQualityOptionList
                }
                value={selectedDiamondQualityValue || []}
                onChange={(selectedOption) => {
                  if (selectedOption.length <= 10) {
                    setSelectedDiamondQualityValue(selectedOption);
                  }
                }}
                isLoading={isLoading}
                labelledBy="Select"
                className={`${errorMessage.selectedDiamondQualityValue ? "border rounded border-danger bg-danger select-invalid dropdown-heading" : "dark"} ${selectedDiamondQualityValue?.length > 0 ? "select-valid" : ""}`}


                // disabled={selectedDiamondQualityValue && selectedDiamondQualityValue.value === 10}
                disabled={
                  selectedDiamondQualityValue &&
                  selectedDiamondQualityValue.value === 10 &&
                  groupValue
                }
                hasSelectAll={false}
                style={{ zIndex: 4 }}
              />
                 
              {errorMessage.selectedDiamondQualityValue && (
                <span className="validation_error">
                  {errorMessage.selectedDiamondQualityValue}
                </span>
              )}
              
            </div>
          </div>
          <div className="d-flex position-relative">
            {/* <div className="col-md-4" style={{ left: "416px", bottom: "50px" }}>
              <Button
                type="submit"
                className="btn btn-dark"
                style={{ width: "150px" }}
              >
                {pricingNo || (priceDetails && priceDetails.length > 0)
                  ? "Update Quotation"
                  : "Create Quotation"}
              </Button>
            </div> */}

            {/* {showError && (
              <Alert
                key={"danger"}
                variant={"danger"}
                message={"Please fill out all required fields correctly."}
                className={"ml-3 alert_formError"}
                showAlert={showError}
              />
            )} */}
          </div>
        </div>

        <div className="col-md-4 d-flex">
          <div className="vertical-line"></div>
          <div className="w-100 px-2">
            <InputComponent
              label={"Pricing Number"}
              value={updatedUniquePriceNumber}
              disabled // Disable the input when pricingNo is not present
              className="w-97"
              type="text"
              placeholder="DMSPRE-XXX"
            />

            <InputComponent
              label={"Pricing Date"}
              value={pricingDate}
              defaultValue={pricingDate}
              disabled
              className={`w-97 mt-3 is-valid`}
              type="text"
            />

            <RadioButton
              elementStyle={{ cursor: "pointer" }}
              label={"Pricing For"}
              disabled={disableInputAction}
              radioBtnList={pricingNoList}
              className="w-100 mt-3"
              value={selectedRadio}
              handleRadioChange={handleRadioChange}
            />

            {deletestoneDetails.priceDetails?.length > 1 && (
              <div
                className="row rounded mt-5 mr-2"
                style={{ backgroundColor: "#e9ecef", marginLeft: "0px" }}
              >
                <div className="form-label py-2 px-1">
                  {selectedRadio === "STYLE"
                    ? "Total Styles"
                    : " Total Designs"}
                  :<span className="form-label pl-1">{styleCount}</span>
                </div>

                <div className="py-2">
                  <ActionBtn
                    exportAction={() => handleAllExcelDownload(data)}
                  />
                </div>
              </div>
            )}

            {/* <button
              className="btn btn-sm btn-secondary my-3"
              type="button"
              onClick={() =>
                handleReCalculateLabour(
                  updateDetails,
                  deletestoneDetails,
                  "multipleLabour"
                )
              }
            >
              Re-Calculate
            </button> */}
          </div>
        </div>
      </div>
    </Form>
  );
};

const ActionBtn = ({ exportAction }) => (
  <FontAwesomeIcon
    type="button"
    title="Download All Excel"
    className="ml-3"
    icon={faDownload}
    size="lg"
    style={{ color: "black" }}
    onClick={exportAction}
  />
);

export default FormComponent;
